<template>
  <v-toolbar dense flat class="cardTitle" color="white">
    <v-toolbar-title>
      <h5 class="font-weight-regular">{{ title }}</h5>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      v-if="showCreate && !hideCancel"
      :data-cy="dataCy"
      outline
      round
      small
      @click="$emit('new')"
    >
      {{ `${this.btnLabel}` }}
    </v-btn>
    <v-btn v-if="isModal && !hideCancel" icon text @click.stop.prevent="cancel">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    btnLabel: {
      default: "buttons.new",
    },
    title: {
      default: "",
    },
    isModal: {
      default: false,
    },
    dataCy: {
      default: "",
    },
    showCreate: {
      default: false,
    },
    hideCancel: {
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped></style>
